import axios from 'axios'
import { getAccessToken } from '@/utils/auth'
import { handleAxiosPromise } from '@/utils/api-common'

const BASE_URL = process.env.BOOLEAN2D_SERVER
const queryUrl = `${BASE_URL}/api/engine-configuration`

export { getEngineConfiguration }

function config () {
  return { headers: { Authorization: `Bearer ${getAccessToken()}` } }
}

function getEngineConfiguration (name) {
  return handleAxiosPromise(axios.get(`${queryUrl}/${encodeURIComponent(name)}`, config()))
}



// WEBPACK FOOTER //
// ./src/utils/engine-configurations-api.js